























import { VozidloPujcovna } from '@/modules/pujcovna/vozidloPujcovna';

import { RozsahDate } from '../constants';
import Base from './Base.vue';
import { editMutations } from '../store/types';

export default Base.extend({
	name: 'KnihaJizd',
	components: {
		BaseFilterSestav: Base,
		VozidloPujcovnaSelect: VozidloPujcovna.components.Select,
	},
	computed: {
		mutationsMappers() : Record<string, string> {
			return {
				vozidloPujcovna: `${this.storeUri}/${editMutations.VOZIDLO_PUJCOVNA_SELECT_MAPPER}`,
			};
		},
		vozidloPaFilter() {
			return { PujcovnaId: this.PujcovnaId };
		},
	},
	created() {
		this.RozsahDate = RozsahDate.casTentoRok;
	},
});
